<template>
    <div>
        <!-- Barcode scanner -->
        <barcode-picker @barcodeHasBeenScanned="barcodeScanned($event)"></barcode-picker>

        <div class="scan-page" v-if="device">

            <!-- Initial Page -->
            <template v-if="!imeiEntered">

                <!-- Manual entry -->
                <div class="container repair-container">
                    <div class="row">
                        <div class="col-12">
                            <label>Manually enter the IMEI</label>
                        </div>
                        <div class="col">
                            <input type="text" class="form-control" inputmode="numeric" pattern="[0-9]*" v-model="imei" v-on:keyup.enter="validateImei()">
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-success" @click="validateImei()">Add</button>
                        </div>
                    </div>
                </div>

                <!-- Validating overlay -->
                <loading-state
                        v-if="validating"
                        overlay
                        title="Validating IMEI">
                </loading-state>
            </template>

            <!-- Valid IMEI -->
            <template v-if="imeiValid && imeiEntered">
                <div class="container repair-container">
                    <empty-state
                            statusIcon="success"
                            :title="`The IMEI <strong>${imei}</strong> is valid for this device`">
                    </empty-state>
                    <div class="row">
                        <div class="col-md-6 offset-md-3">
                            <button class="btn btn-block btn-info" @click="clearImei()">Re-enter IMEI</button>
                        </div>
                    </div>
                </div>
            </template>

            <!-- Invalid IMEI -->
            <template v-if="!imeiValid && imeiEntered">
                <div class="container repair-container">
                    <empty-state
                            statusIcon="error"
                            :title="`The IMEI <strong>${imei}</strong> is not valid for this device`"
                            subtitle="Click the button below to re-enter the IMEI or contact your SSM if you require more help">
                    </empty-state>
                    <div class="row">
                        <!--                    <div class="col-6">-->
                        <!--                        <button class="btn btn-block btn-danger btn-sm">IMEI mismatch</button>-->
                        <!--                    </div>-->
                        <div class="col-md-6 offset-md-3">
                            <button class="btn btn-block btn-info" @click="clearImei()">Re-enter IMEI</button>
                        </div>
                    </div>
                </div>
            </template>

            <!-- Footer -->
            <fixed-footer
                    :class="{'active': footerActive}"
                    :nextLabel="this.nextRepairStep($route.name).title"
                    :nextRoute="this.nextRepairStep($route.name).routeName"
                    :prevRoute="this.prevRepairStep($route.name).routeName">
            </fixed-footer>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import Validator from '../../services/validateImei';

    export default {

        props:["jobId", "deviceId"],

        data() {
            return {
                imei:null,
                imeiEntered: false,
                imeiValid: false,
                validating: false,
                numbers:[1234567891]
            }
        },

        mounted() {
            this.loadDeviceForJob({
                jobId: this.jobId,
                deviceId: this.deviceId,
            }).then(() => {
                this.setCurrentStep({
                    jobId: this.jobId,
                    deviceId: this.deviceId,
                    currentStep: this.$route.name,
                });
            });
        },

        computed: {
            ...mapGetters([
                "device",
                "deviceImei",
                "isSuperAdmin",
                "nextRepairStep",
                "prevRepairStep"
            ]),

            /** Check if footer should be active */
            footerActive() {
                if (this.device.imei_scanned || this.isSuperAdmin) {
                    return true;
                }

                return false;
            }
        },

        methods: {
            ...mapActions([
                "clearImeiScanned",
                "displayToast",
                "loadDeviceForJob",
                "saveImei",
                "setCurrentStep",
                "setDeviceImei"
            ]),

            /** Barcode scan */
            barcodeScanned(barcode) {
                this.imei = barcode.data;
                this.validateImei();
            },

            /** Clear IMEI */
            clearImei() {
                this.imei = null;
                this.imeiEntered = false;
                this.imeiValid = false;
                this.clearImeiScanned({
                    jobId: this.jobId,
                    deviceId: this.deviceId
                })
            },

            /** Validate IMEI */
            validateImei() {
                this.validating = true;

                let validator = new Validator(this.imei);
                let imeiValid = validator.isValid();

                if (!imeiValid) {
                    this.imeiValid = false;
                    this.validating = false;
                    this.imeiEntered = true;
                    return;
                }

                this.imeiValid = true;

                this.saveImei({
                    jobId: this.jobId,
                    deviceId: this.deviceId,
                    imei: this.imei
                }).then(() => {
                    // this.setDeviceImei(imei);
                    this.footerActive = true;
                    this.validating = false;
                    this.imeiEntered = true;
                    // TODO: handle messaging
                }).catch((error) => {
                    this.footerActive = false;
                    this.validating = false;
                    this.imeiEntered = false;
                    this.displayToast({text: error, type: 'danger'});
                })
            }
        }
    }
</script>

<style scoped>

</style>